import { useSnapshot } from "valtio";

import { state } from "./State";
import * as Types from "./types";

const useSnapshotState = () => {
  return useSnapshot(state);
};

export const useOpenTagField = (): boolean => {
  const snapshot = useSnapshotState();
  return snapshot.tagField.open;
};

export const useDeleteDialogTargetTagName = (): string | undefined => {
  const snapshot = useSnapshotState();
  return snapshot.deleteDialog.targetTagName;
};

export const useTags = (): Types.TagItem[] => {
  const snapshot = useSnapshotState();
  return Array.from(snapshot.tagsMap.values());
};
